import type { SafeToolInfo } from '@magicschool/business-logic/tools';
import type { Tables } from '@magicschool/supabase/types';
import type { RoomBuilderForm } from 'app/(teacher)/magic-student/rooms/_components/RoomBuilder/FormFields/RoomBuilderFormSchema';
import type { ToolCustomization } from 'features/rooms/types';
import { toInsertToolCustomization } from 'features/rooms/types';

type RoomBuilderToolData = RoomBuilderForm['roomTools'][number];
type ApiRoomToolData = {
  room_tool: Tables<'room_tools'>;
  tool_customization: ToolCustomization | null;
  toolDetails?: SafeToolInfo | null;
  toolTitle: string;
  toolDescription: string;
  toolIcon?: string;
  isDisabled?: boolean;
};

type RoomToolInput = RoomBuilderToolData | ApiRoomToolData;

export const normalizeRoomToolData = (roomTool: RoomToolInput) => {
  const isRoomBuilderToolData = (roomTool: RoomToolInput): roomTool is RoomBuilderToolData => {
    return 'toolSlug' in roomTool;
  };

  const isApiRoomToolData = (roomTool: RoomToolInput): roomTool is ApiRoomToolData => {
    return 'room_tool' in roomTool;
  };

  if (isRoomBuilderToolData(roomTool)) {
    return {
      tool_slug: roomTool.toolSlug,
      tool_uuid: roomTool.toolUuid,
      tool_customization: roomTool.toolCustomization
        ? toInsertToolCustomization({
            ...roomTool.toolCustomization,
            teacher_id: '',
            updated_by_teacher_id: '',
          })
        : null,
      room_tool_id: roomTool.roomToolId || roomTool.roomToolFormId || '',
      toolIcon: roomTool.toolIcon || '',
    };
  } else if (isApiRoomToolData(roomTool)) {
    return {
      tool_slug: roomTool.room_tool.tool_id,
      tool_uuid: roomTool.room_tool.tool_uuid,
      tool_customization: roomTool.tool_customization
        ? {
            name: roomTool.tool_customization.name,
            teacher_id: roomTool.tool_customization.teacher_id,
            tool_slug: roomTool.tool_customization.tool_slug,
            tool_uuid: roomTool.tool_customization.tool_uuid,
            json_config: roomTool.tool_customization.json_config,
            updated_by_teacher_id: roomTool.tool_customization.updated_by_teacher_id,
          }
        : null,
      room_tool_id: roomTool.room_tool.id || '',
      toolIcon: roomTool.toolIcon || roomTool.toolDetails?.tool?.icon || '',
    };
  } else {
    throw new Error('Invalid room tool data type');
  }
};
